module.exports = __webpack_public_path__ + "img/onboarding_paso1.06bf334c.png";